/**
 * Roles that confer systray administration (odoo-5133).
 *
 * `systray-admin` is the cover-systray client's own admin role — the proper,
 * app-scoped way to grant administration of this app without handing out a
 * realm-wide role. `admin` / `administrator` are the legacy realm-level roles,
 * kept for backward compatibility with existing super-admin accounts.
 *
 * Shared by the route guard and UserService so "what counts as an admin" lives
 * in exactly one place on the front (the API mirrors this set in
 * UserContextService.IsAdmin).
 */
export const ADMIN_ROLES: string[] = ['systray-admin', 'admin', 'administrator'];

/** True if any of the given role names confers systray administration. */
export function hasAdminRole(...roleLists: readonly string[][]): boolean {
  return roleLists.some((roles) => roles.some((r) => ADMIN_ROLES.includes(r)));
}
